import '../scripts/support-menu.js'
import '../scripts/article-main.js'
import '../scripts/video-control.js'
import '../scripts/sticky-atc-card.js'
import '../scripts/newsletter-form.js'
import '../scripts/image-load.js'
import { startSchemaPlusJsonLdPatching } from '../scripts/patch-schema-plus-jsonld.js';

document.addEventListener('DOMContentLoaded', () => {
  startSchemaPlusJsonLdPatching({ log: false });
});

